import CustomTooltip from "app/components/Tooltip";
import Avatar from "app/containers/Features/components/Avatar";
import CommonAssigneeSelection from "app/containers/Features/components/CommonAssigneeSelection";
import { members } from "app/containers/Features/containers/ProjectSettings/data";
import { IMember } from "app/containers/Features/containers/ProjectSettings/types";
import React, { useState } from "react";

interface AssigneeSelectionProps {
  assignedTo: {
    name: string;
    color: string;
    status?: "online" | "offline";
    online: boolean;
  }[];
}

const Assignee: React.FC<AssigneeSelectionProps> = ({ assignedTo }) => {
  const [search, setSearch] = useState("");

  function searchMembers(
    members: IMember[] | undefined,
    keyword: string
  ): IMember[] {
    if (!keyword || !members) {
      return members ? members : [];
    }

    const lowerCaseKeyword = keyword.toLowerCase();

    return members.filter((member) => {
      return (
        member.name.toLowerCase().includes(lowerCaseKeyword) ||
        member.role.toLowerCase().includes(lowerCaseKeyword)
      );
    });
  }

  const filteredMembers = searchMembers(members, search);

  return (
    <>
      <CommonAssigneeSelection
        trigger={
          <button className="flex items-center justify-between w-full">
            <CustomTooltip
              text="Set assignee"
              className="flex items-center gap-1"
              position="left"
            >
              {assignedTo?.map((assignee, index) => (
                <Avatar
                  key={index}
                  className="!min-w-[190px] mr-2"
                  color={assignee?.color}
                  name={assignee?.name}
                />
              ))}
            </CustomTooltip>
          </button>
        }
        align="center"
        searchKeyword={search}
        setSearchKeyword={(val) => {
          setSearch(val);
        }}
        data={filteredMembers}
        selectedValue={assignedTo?.map((a) => a.name).join(", ") ?? ""}
        updateValue={function (member: IMember): void {
          console.log("Selected member:", member);
          // Implement the logic to handle the selected member here
        }}
        isHeader="Assignees"
        searchPlaceholder="Search by assignee or role"
      />
    </>
  );
};

export default Assignee;
